import './index.scss'
import subLogo from '../../assets/Images/sub-logo.png'
import logo from '../../assets/Images/newlogo.png'
import { NavLink, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faFile, faHome, faListCheck,  faSuitcase, faUser, faX } from '@fortawesome/free-solid-svg-icons'


export default function Navbar (){
    const navigate=useNavigate()
    const [responsive,setResponsive]=useState(false)

    return(
        <div>
                <nav className='navbar'>
                    <div role='button' onClick={()=>navigate('/')} className='logos'>
                        <img className='logo' alt='logo' src={logo}/>
                        <img className='sub-logo' alt='sub-logo' src={subLogo} />
                    </div>
                    <div className="websites">
                        <NavLink exact='true' activeclassname='active' className='home-link' to={'/'}>
                            <FontAwesomeIcon icon={faHome} size={'xl'} color='#fff'/>
                        </NavLink>
                        <NavLink exact='true'  activeclassname='active' className='about-link' to={'/about'}>
                            <FontAwesomeIcon icon={faUser} size={'xl'} color='#fff'/>
                        </NavLink>
                        <NavLink exact='true'  activeclassname='active' className='project-link' to={'/projects'}>
                            <FontAwesomeIcon icon={faSuitcase} size={'xl'} color='#fff'/>
                        </NavLink>
                        <NavLink exact='true'  activeclassname='active' className='contact-link' to={'/contact'}>
                            <FontAwesomeIcon icon={faEnvelope} size={'xl'} color='#fff'/>
                        </NavLink>
                        <NavLink exact='true'  activeclassname='active' className='resume-link' to={'/resume'}>
                            <FontAwesomeIcon icon={faFile} size={'xl'} color='#fff'/>
                        </NavLink>
                    </div>
                    <div className='responsive'>
                        {!responsive && <button className='list-check' onClick={()=>{setResponsive(true)}}>
                            <FontAwesomeIcon icon={faListCheck}/>
                        </button>
                        }
                    </div>
                </nav>
                { responsive &&
                // <div className="navbar-page">
                <nav className='arrange'>
                    <div role='button' onClick={()=>navigate('/')} className='res-logos'>
                        <img className='logo' alt='logo' src={logo}/>
                        <img className='sub-logo' alt='sub-logo' src={subLogo} />
                    </div>
                    <div className='list'>
                        <button><a href="/">Home</a></button>
                        <button><a href="/about">About</a></button>
                        <button><a href="/projects">Projects</a></button>
                        <button><a href="/contact">Contact</a></button>
                        <button><a href="/resume">Resume</a></button>
                    </div>
                    <button className='cross' onClick={()=>setResponsive(false)}>
                        <FontAwesomeIcon icon={faX}/>
                    </button>
                </nav>
                // </div>
                }   
        </div>
    )
}